<template>
  <div>
    <b-card class="mt-4">
      <b-overlay :show="busy" rounded="sm">
        <div class="row pb-3">
          <div class="col">
            <h3>Tunele chłodzące</h3>
          </div>
          <div class="col">
            <button
              type="button"
              class="btn btn-primary float-right"
              @click="AddItem"
            >
              <i class="fas fa-plus-circle fa-1x"></i> Dodaj tunel chłodzący
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-md-1 font-weight-bold">ID</div>
          <div class="col-md-3 font-weight-bold">Nazwa</div>
          <div class="col-md-2 font-weight-bold">Rozmiar</div>
          <div class="col-md-4 font-weight-bold">Numer seryjny</div>
          <div class="col-md-2 font-weight-bold">Akcje</div>
        </div>
        <div class="row p-1" v-for="item in coolingTunnels" :key="item.id">
          <div class="col-md-1">#{{ item.id }}</div>
          <div class="col-md-3">
            <input
              type="text"
              :disabled="!item.isEdit"
              class="form-control"
              v-model="item.name"
            />
          </div>
          <div class="col-md-2">
            <v-select
              :options="tunnelSize"
              :disabled="!item.isEdit"
              label="name"
              v-model="item.size"
              :reduce="(x) => x.id"
            ></v-select>
          </div>
          <div class="col-md-4">
            <input
              type="text"
              :disabled="!item.isEdit"
              class="form-control"
              v-model="item.serialNumber"
            />
          </div>
          <div class="col-md-2 div-icons-area">
            <span @click="SaveData(item)" v-if="item.isEdit"
              ><i class="fas fa-check fa-lg color-green"></i
            ></span>
            <span @click="ChangeEditStatus(item, false)" v-if="item.isEdit">
              <i class="fas fa-times fa-lg color-red"></i>
            </span>
            <span
              v-if="!item.isEdit"
              @click="ChangeEditStatus(item, true)"
              v-b-tooltip.hover
              title="Zmień nazwę tunelu"
            >
              <i class="fas fa-edit fa-lg"></i
            ></span>
            <span
              v-b-tooltip.hover
              title="Usuń tunel"
              v-if="!item.isEdit"
              @click="RemoveCoolingTunnel(item)"
            >
              <i class="fas fa-trash fa-lg"></i>
            </span>
          </div>
        </div>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import urlConfig from "../../../mixins/url";
import toastr from "../../../mixins/toastr";
import axios from "axios";

export default {
  name: "AdministrationCoolingTunnel",
  components: {},
  mixins: [urlConfig, toastr],
  mounted() {
    this.$store.dispatch("CoolingTunnel/getCoolingTunnels");
    this.isLoaded = true;
  },
  computed: {
    coolingTunnels() {
      return this.$store.state.CoolingTunnel.coolingTunnels;
    },
  },
  data() {
    return {
      localCopy: [],
      tunnelSize: [
        { name: "Duży", id: 2 },
        { name: "Mały", id: 1 },
      ],
      isLoaded: false,
      busy: false,
    };
  },
  methods: {
    IsValid(item) {
      if (!item.name || !item.size || !item.serialNumber) {
        this.DisplayError("Błąd!", "Nie wszystkie pola są wypełnione");
        return false;
      }
      return true;
    },
    AddItem() {
      this.coolingTunnels.unshift({ isEdit: true });
    },
    SaveData(item) {
      if (item.id) {
        this.UpdateCoolingTunnel(item);
      } else {
        this.SaveNewCoolingTunnel(item);
      }
    },
    SaveNewCoolingTunnel(item) {
      if (this.IsValid(item)) {
        var url = this.url.serverUrl + this.url.CoolingTunnel.Create;
        var that = this;
        this.busy = true;
        axios
          .post(url, item)
          .then(function (response) {
            item.isEdit = false;
            item.id = response.data.data;
            that.DisplaySuccess(
              "Sukces!",
              "Nowy tunel chłodzący '" + item.name + "' został dodany"
            );
            that.busy = false;
          })
          .catch(function (e) {
            that.busy = false;
            that.DisplayError("Błąd!", e);
            console.log(e);
          });
      }
    },
    UpdateCoolingTunnel(item) {
      var url = this.url.serverUrl + this.url.CoolingTunnel.Edit;
      var that = this;
      this.busy = true;
      axios
        .post(url, item)
        .then(function (response) {
          if (response.data.success) {
            item.isEdit = false;
            that.DisplaySuccess("Sukces!", "Tunel został zaktualizowany");
            that.busy = false;
          } else {
            that.DisplayError("Błąd!", response.data.error[0]);
          }
        })
        .catch(function (e) {
          that.busy = false;
          that.DisplayError("Błąd!", e);
          console.log(e);
        });
    },
    RemoveCoolingTunnel(item) {
      if (confirm("Czy napewno chcesz usunać tunel: " + item.name)) {
        var that = this;
        this.busy = true;
        axios
          .delete(
            `${this.url.serverUrl}${this.url.CoolingTunnel.Remove}${item.id}`
          )
          .then(function () {
            var index = that.coolingTunnels.findIndex((x) => x.id == item.id);
            that.coolingTunnels.splice(index, 1);
            that.busy = false;
          })
          .catch(function (e) {
            console.log(e);
            that.DisplayError("Błąd!", e);
            that.busy = false;
          });
      }
    },

    ChangeEditStatus(item, status) {
      if (status == true) {
        this.localCopy.push(Object.assign({}, item));
      } else {
        if (!item.id) {
          var index = this.coolingTunnels.findIndex((x) => x.id == undefined);
          this.coolingTunnels.splice(index, 1);
        }
        var rootItem = this.localCopy.filter((x) => x.id == item.id)[0];
        item.name = rootItem.name;
        item.size = rootItem.size;
        item.serialNumber = rootItem.serialNumber;
        this.localCopy = this.localCopy.filter((x) => x.id != item.id);
      }
      item.isEdit = status;
    },
  },
};
</script>